import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingminibusrentalinpune() {



  const cardData = {
"keyword": "Wedding Mini Bus Rental in Pune",

"headingDescription":
  "Aaradhya Travels offers reliable Wedding Mini Bus Rental in Pune for marriage functions, guest transportation, destination weddings, family events, airport transfers, and group travel arrangements. Our fleet includes comfortable 14, 17, 20, 25, 32, and 35-seater mini buses equipped with pushback seats, spacious interiors, air-conditioning, and professional drivers to ensure smooth wedding transportation across Pune and nearby destinations. We provide timely pickup and drop services for wedding guests, family members, baraat events, reception functions, and venue transfers with safe and hassle-free travel experience.",

"topPlaces": [

{
"title": "Lavasa",
"description":
"Lavasa is a planned hill city near Pune known for lakeside promenade, colorful buildings, cafes, and peaceful environment. It is ideal for relaxed group outings, corporate trips, and family leisure travel."
},
{
"title": "Pawna Lake",
"description":
"Pawna Lake is a scenic lakeside destination near Lonavala known for camping, sunset views, bonfire nights, and peaceful surroundings. It is highly popular among group travelers and weekend tourists from Pune."
},
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station known for toy train rides, viewpoints, and cool weather. It is perfect for peaceful group travel and family sightseeing tours from Pune."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a calm hill station known for Arthur Lake, Randha Falls, and natural beauty. It is a perfect relaxing destination for group tours and weekend trips from Pune."
},
{
"title": "Kamshet",
"description":
"Kamshet is a scenic hill region near Pune famous for paragliding, green valleys, and peaceful landscapes. It is popular among adventure lovers and group travelers looking for short trips."
},
{
"title": "Khandala",
"description":
"Khandala is a popular hill station near Pune known for its misty mountains, scenic viewpoints, waterfalls, and pleasant weather. It is a favorite weekend getaway for families and group travelers using buses and Tempo Travellers for comfortable short road trips."
},
{
"title": "Lonavala",
"description":
"Lonavala is one of the most famous hill stations near Pune known for green valleys, Tiger Point, Bhushi Dam, caves, and monsoon beauty. It is widely visited by family groups, corporate teams, and friends for short and comfortable bus trips."
},
{
"title": "Mulshi",
"description":
"Mulshi is a beautiful lake and dam destination near Pune surrounded by hills and greenery. It is a popular picnic and one-day group travel destination for families and corporate outings."
},
{
"title": "Tamhini Ghat",
"description":
"Tamhini Ghat is a scenic mountain pass known for waterfalls, fog, and lush greenery during monsoon. It is a favorite short road trip destination for group travelers from Pune."
},
{
"title": "Aamby Valley",
"description":
"Aamby Valley is a luxury hill township near Lonavala known for scenic landscapes, lakes, and premium resorts. It is popular for corporate trips, luxury group outings, and weekend leisure travel."
}
],



services: [
  {
    name: "Wedding Mini Bus Rental in Pune",
    description: "Wedding mini bus rental in Pune service provides comfortable transportation for bridal parties, wedding guests, family members, and marriage event travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding ceremonies, receptions, and family gatherings. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, hotels, banquet halls, and wedding venues across Pune. Flexible booking options allow convenient wedding mini bus reservations."
  },
  {
    name: "Wedding Bus Hire in Pune",
    description: "Wedding bus hire in Pune service offers dependable transportation for marriage ceremonies, wedding receptions, engagement functions, and family events. Comfortable buses provide spacious seating suitable for transporting wedding guests and relatives together. Professional drivers ensure safe transportation and timely pickup services throughout the wedding journey. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient wedding bus hire reservations."
  },
  {
    name: "Mini Bus for Marriage in Pune",
    description: "Mini bus for marriage in Pune service provides stylish and spacious transportation for wedding guests, family travel, and bridal event transportation requirements. Comfortable seating and smooth travel ensure enjoyable journeys suitable for marriage ceremonies and celebrations. Professional chauffeurs ensure punctual transportation and safe driving services throughout the wedding schedule. Pickup services are available from homes, hotels, banquet halls, and residential areas across Pune. Flexible booking options allow convenient marriage mini bus reservations."
  },
  {
    name: "Wedding Transport Service Pune",
    description: "Wedding transport service Pune offers reliable transportation for wedding ceremonies, reception events, guest movement, and family travel requirements. Spacious vehicles ensure smooth travel suitable for marriage functions, destination weddings, and wedding-related group transportation. Professional drivers ensure safe transportation and dependable pickup services throughout the wedding event schedule. Pickup services are available from homes, hotels, airports, and banquet halls across Pune. Flexible booking options allow convenient wedding transport reservations."
  },
  {
    name: "Luxury Wedding Mini Bus Pune",
    description: "Luxury wedding mini bus Pune service offers premium transportation with spacious interiors and elegant seating for marriage ceremonies, VIP guests, and family travel. Comfortable luxury buses ensure smooth journeys suitable for destination weddings and high-end wedding events. Professional chauffeurs ensure punctual pickup and safe driving services throughout the route. Pickup services are available from homes, luxury hotels, airports, and wedding venues across Pune. Flexible booking options allow convenient luxury wedding bus reservations."
  },
  {
    name: "AC Mini Bus for Wedding Pune",
    description: "AC mini bus for wedding Pune service provides air-conditioned transportation for marriage ceremonies, wedding guests, bridal parties, and family travel requirements. Comfortable seating and cooling systems ensure pleasant journeys suitable for all weather conditions and wedding events. Professional chauffeurs ensure reliable transportation and punctual pickup services throughout the wedding schedule. Pickup services are available from homes, hotels, banquet halls, and airports across Pune. Flexible booking options allow convenient AC wedding mini bus reservations."
  },
  {
    name: "Non AC Wedding Bus Pune",
    description: "Non AC wedding bus Pune service offers affordable transportation for marriage ceremonies, engagement functions, wedding receptions, and family gatherings. Spacious buses ensure comfortable travel suitable for transporting guests and relatives to wedding venues. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, banquet halls, and residential areas across Pune. Flexible booking options allow convenient non AC wedding bus reservations."
  },
  {
    name: "Wedding Guest Transport Pune",
    description: "Wedding guest transport Pune service provides dependable transportation for wedding attendees, family members, relatives, and group travel during marriage functions. Spacious seating and smooth travel ensure comfortable journeys suitable for local and outstation wedding events. Professional chauffeurs ensure timely transportation and safe driving services throughout the wedding itinerary. Pickup services are available from homes, hotels, airports, railway stations, and wedding venues across Pune. Flexible booking options allow convenient wedding guest transport reservations."
  },
  {
    name: "Marriage Function Bus Hire Pune",
    description: "Marriage function bus hire Pune service offers reliable transportation for engagement ceremonies, wedding receptions, family functions, and marriage-related group travel. Spacious buses ensure smooth journeys suitable for transporting wedding guests and family members together. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, banquet halls, and residential areas across Pune. Flexible booking options allow convenient marriage function bus reservations."
  },
  {
    name: "Wedding Bus on Rent Pimpri Chinchwad",
    description: "Wedding bus on rent Pimpri Chinchwad service provides comfortable transportation for marriage ceremonies, wedding receptions, guest movement, and family travel requirements. Spacious buses ensure smooth travel suitable for local and outstation wedding functions. Professional chauffeurs ensure dependable transportation and timely pickup services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, and residential areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "Wedding Bus on Rent Kharadi",
    description: "Wedding bus on rent Kharadi service offers dependable transportation for bridal events, marriage ceremonies, wedding receptions, and family travel requirements. Spacious seating and smooth travel ensure pleasant journeys suitable for wedding celebrations and guest movement. Professional drivers ensure safe transportation and punctual pickup services throughout the wedding event schedule. Pickup services are available from homes, hotels, banquet halls, and residential areas across Kharadi Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "Wedding Bus on Rent Hadapsar",
    description: "Wedding bus on rent Hadapsar service provides reliable transportation for wedding functions, family gatherings, guest transfers, and marriage ceremonies. Spacious buses ensure comfortable journeys suitable for transporting guests and relatives together during wedding events. Professional chauffeurs ensure safe driving and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, hotels, banquet halls, and residential areas across Hadapsar Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "Wedding Bus on Rent Baner",
    description: "Wedding bus on rent Baner service offers stylish and spacious transportation for bridal events, marriage functions, wedding receptions, and guest movement requirements. Comfortable seating ensures smooth journeys suitable for local and destination wedding travel. Professional drivers ensure punctual transportation and safe driving services throughout the wedding itinerary. Pickup services are available from homes, hotels, banquet halls, and residential areas across Baner Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "Wedding Bus on Rent Hinjewadi",
    description: "Wedding bus on rent Hinjewadi service provides dependable transportation for wedding ceremonies, office colleague travel, family functions, and marriage event transportation. Spacious buses ensure comfortable journeys suitable for transporting groups of wedding guests and relatives. Professional chauffeurs ensure safe transportation and timely pickup services throughout the wedding event schedule. Pickup services are available from homes, hotels, banquet halls, and corporate locations across Hinjewadi Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "Wedding Bus for Outstation Pune",
    description: "Wedding bus for outstation Pune service offers reliable long-distance transportation for destination weddings, family functions, and marriage ceremonies outside Pune. Spacious buses ensure smooth highway travel suitable for transporting guests and relatives comfortably. Professional drivers ensure safe driving and dependable transportation services throughout the outstation wedding journey. Pickup services are available from homes, hotels, banquet halls, and residential areas across Pune. Flexible booking options allow convenient outstation wedding bus reservations."
  },
  {
    name: "Wedding Bus for Destination Wedding Pune",
    description: "Wedding bus for destination wedding Pune service provides premium transportation for luxury weddings, resort weddings, and family travel to outstation wedding destinations. Spacious seating and luggage capacity ensure comfortable journeys suitable for wedding groups and guest travel. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the destination wedding schedule. Pickup services are available from homes, airports, hotels, and wedding venues across Pune. Flexible booking options allow convenient destination wedding bus reservations."
  },
  {
    name: "Affordable Wedding Bus Pune",
    description: "Affordable wedding bus Pune service provides economical transportation for marriage ceremonies, engagement functions, wedding receptions, and family gatherings. Spacious buses ensure smooth travel suitable for transporting guests and relatives comfortably within budget-friendly travel options. Professional drivers ensure dependable transportation and safe driving services throughout the wedding itinerary. Pickup services are available from homes, hotels, banquet halls, and residential areas across Pune. Flexible booking options allow convenient affordable wedding bus reservations."
  },
  {
    name: "Premium Wedding Mini Bus Pune",
    description: "Premium wedding mini bus Pune service offers luxury transportation for bridal parties, VIP wedding guests, destination weddings, and executive family travel requirements. Elegant interiors and spacious seating ensure smooth journeys suitable for premium wedding events and celebrations. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the route. Pickup services are available from homes, luxury hotels, airports, and banquet halls across Pune. Flexible booking options allow convenient premium wedding mini bus reservations."
  },
  {
    name: "17 Seater Wedding Mini Bus Pune",
    description: "17 seater wedding mini bus Pune service provides spacious transportation for wedding guests, family travel, engagement functions, and marriage event transportation requirements. Comfortable seating and smooth travel ensure pleasant journeys suitable for medium-sized wedding groups. Professional drivers ensure safe transportation and dependable pickup services throughout the wedding schedule. Pickup services are available from homes, hotels, banquet halls, and residential areas across Pune. Flexible booking options allow convenient 17 seater wedding mini bus reservations."
  },
  {
    name: "25 Seater Wedding Bus Pune",
    description: "25 seater wedding bus Pune service offers dependable group transportation for marriage ceremonies, wedding receptions, family functions, and destination wedding travel. Spacious seating and luggage capacity ensure comfortable journeys suitable for large wedding groups and guest movement. Professional chauffeurs ensure safe driving and punctual transportation services throughout the wedding itinerary. Pickup services are available from homes, hotels, banquet halls, and airports across Pune. Flexible booking options allow convenient 25 seater wedding bus reservations."
  },
  {
    name: "Corporate Wedding Transport Pune",
    description: "Corporate wedding transport Pune service provides professional transportation for office wedding events, corporate guest travel, employee wedding functions, and executive family ceremonies. Spacious buses ensure smooth travel suitable for transporting office teams and wedding guests together. Professional drivers ensure reliable transportation and punctual pickup services throughout the wedding event schedule. Pickup services are available from offices, hotels, banquet halls, and residential areas across Pune. Flexible booking options allow convenient corporate wedding transport reservations."
  },
  {
    name: "Wedding Shuttle Service Pune",
    description: "Wedding shuttle service Pune offers convenient transportation for moving guests between wedding venues, hotels, airports, and banquet halls during marriage ceremonies and receptions. Comfortable buses ensure smooth travel suitable for wedding guest management and group transportation. Professional chauffeurs ensure timely transportation and dependable pickup services throughout the event. Pickup services are available from homes, hotels, railway stations, airports, and wedding venues across Pune. Flexible booking options allow convenient wedding shuttle reservations."
  },
  {
    name: "Bus Hire for Wedding Events Pune",
    description: "Bus hire for wedding events Pune service provides reliable transportation for engagement ceremonies, bridal showers, wedding receptions, family gatherings, and marriage-related functions. Spacious buses ensure comfortable journeys suitable for transporting guests and relatives together. Professional drivers ensure safe transportation and dependable pickup services throughout the wedding event schedule. Pickup services are available from homes, hotels, banquet halls, and residential areas across Pune. Flexible booking options allow convenient wedding event bus reservations."
  },
  {
    name: "Wedding Group Travel Pune",
    description: "Wedding group travel Pune service offers spacious transportation for bridal parties, wedding guests, family groups, and destination wedding journeys. Comfortable seating and luggage space ensure smooth travel experiences suitable for local and outstation marriage events. Professional chauffeurs ensure punctual transportation and safe driving services throughout the wedding schedule. Pickup services are available from homes, hotels, airports, and wedding venues across Pune. Flexible booking options allow convenient wedding group travel reservations."
  },
  {
    name: "Pune Wedding Bus Booking",
    description: "Pune wedding bus booking service provides convenient transportation solutions for marriage ceremonies, family functions, engagement events, and wedding guest movement requirements. Spacious buses ensure smooth travel suitable for transporting wedding attendees and relatives comfortably. Professional drivers ensure reliable transportation and punctual pickup services throughout the wedding itinerary. Pickup services are available from homes, hotels, banquet halls, airports, and residential areas across Pune. Flexible booking options allow convenient Pune wedding bus reservations."
  }
],

tableData: [
  ["Wedding Mini Bus Rental in Pune", "Wedding Bus Hire in Pune"],
  ["Mini Bus for Marriage in Pune", "Wedding Transport Service Pune"],
  ["Luxury Wedding Mini Bus Pune", "AC Mini Bus for Wedding Pune"],
  ["Non AC Wedding Bus Pune", "Wedding Guest Transport Pune"],
  ["Marriage Function Bus Hire Pune", "Wedding Bus on Rent Pimpri Chinchwad"],
  ["Wedding Bus on Rent Kharadi", "Wedding Bus on Rent Hadapsar"],
  ["Wedding Bus on Rent Baner", "Wedding Bus on Rent Hinjewadi"],
  ["Wedding Bus for Outstation Pune", "Wedding Bus for Destination Wedding Pune"],
  ["Affordable Wedding Bus Pune", "Premium Wedding Mini Bus Pune"],
  ["17 Seater Wedding Mini Bus Pune", "25 Seater Wedding Bus Pune"],
  ["Corporate Wedding Transport Pune", "Wedding Shuttle Service Pune"],
  ["Bus Hire for Wedding Events Pune", "Wedding Group Travel Pune"],
  ["Pune Wedding Bus Booking", "Wedding Mini Bus Rental in Pune"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Tempo Traveller on Rent in Aundh Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable Tempo Traveller rental service in Aundh Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for corporate trips, family tours, and group travel."
      },
      {
        WhyChooseheading: "Affordable Tempo Traveller Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Tempo Traveller on rent in Aundh Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking Service",
        WhyChoosedescription: "Our Tempo Traveller rental service in Aundh Pune operates 24 hours for airport transfers, employee transportation, weddings, pilgrimage tours, corporate outings, and outstation travel."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, office outings, pilgrimage journeys, and multi-day outstation travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "13, 17 & 20 Seater Tempo Traveller Options",
        WhyChoosedescription: "Customers can choose from 13 seater, 17 seater, and 20 seater Tempo Travellers suitable for office teams, family groups, wedding travel, tourists, and employee transportation."
      },
      {
        WhyChooseheading: "Quick Pickup Service in Aundh & Nearby Areas",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Aundh, Baner, Pashan, Balewadi, Wakad, Shivajinagar, University Road, and nearby Pune locations for hassle-free travel."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local sightseeing and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Tempo Traveller on rent in Aundh Pune?", answer: "Tempo Traveller rental service in Aundh Pune provides comfortable group transportation for corporate travel, family tours, weddings, and outstation journeys." },
    { question: "Is Tempo Traveller booking available 24 hours in Aundh?", answer: "Yes, Aaradhya Travels provides 24/7 Tempo Traveller rental service in Aundh Pune." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, and 20 seater Tempo Travellers for different group travel requirements." },
    { question: "Can I book Tempo Traveller for outstation travel from Aundh?", answer: "Yes, customers can book Tempo Travellers for outstation tours, hill station trips, pilgrimage journeys, and holiday travel from Aundh Pune." },
    { question: "Do you provide Tempo Travellers for corporate events in Aundh?", answer: "Yes, Aaradhya Travels provides Tempo Traveller rental service for corporate meetings, office outings, conferences, and employee transportation in Aundh." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book Tempo Traveller online in Aundh Pune?", answer: "Yes, customers can easily book Tempo Traveller rental service online or through phone booking." },
    { question: "Do you provide Tempo Travellers for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious Tempo Travellers suitable for weddings, family vacations, and group tours." },
    { question: "Are Tempo Traveller rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Tempo Traveller rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, corporate events, and peak travel periods." }
  ];

  const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Kulkarni",
    feedback:
      "Group travel from Aundh Pune was very smooth with Aaradhya Travels arranging a Tempo Traveller. The ride was comfortable, and everyone could travel together without any inconvenience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rutuja Joshi",
    feedback:
      "Aaradhya Travels provided a Tempo Traveller on rent in Aundh Pune for our family trip, and the experience was very well managed. The vehicle was clean, spacious, and made the journey comfortable for all.",
    rating: 5
  }
];









  


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Mini Bus Rental in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/wedding-mini-bus-rental-pune.jpg",
  "description": "Book Wedding Mini Bus Rental in Pune with Aaradhya Travels for marriage functions, guest transportation, and family events. Available in AC, Non-AC, and luxury mini buses across Pune and Pimpri Chinchwad for smooth wedding travel arrangements.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5108"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/wedding-mini-bus-rental-in-pune"
  }
};



  return (
    <div>

<Helmet>
  <title>
    Wedding Mini Bus Rental in Pune | Marriage Guest Transport | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Wedding Mini Bus Rental in Pune with Aaradhya Travels. Affordable AC, Non-AC, and luxury mini buses available for marriage functions, guest transport, wedding ceremonies, and group travel across Pune and Pimpri Chinchwad."
  />

  <meta
    name="keywords"
    content="Wedding mini bus rental in Pune, Wedding bus hire in Pune, Mini bus for marriage in Pune, Wedding transport service Pune, Luxury wedding mini bus Pune, AC mini bus for wedding Pune, Non AC wedding bus Pune, Wedding guest transport Pune, Marriage function bus hire Pune, Wedding bus on rent Pimpri Chinchwad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/45.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Weddingminibusrentalinpune;